import React from 'react';
import {AbstractStand} from "./AbstractStand";

export const StandS = (props) => <AbstractStand height="20" width="40" type={"S"} {...props}/>;

